<template>
    <section class="cta-support">
        <div class="container container-tight">
            <h2 v-show="activeCategory">{{ $t('cta_title') }}</h2>
            <h2 v-show="!activeCategory">{{ $t('cta_title_2') }}</h2>
            <p v-html="$t('cta_sub_title')" v-show="activeCategory && activeCategory !== 'content'"></p>
            <p v-html="$t('cta_sub_title_3')" v-show="activeCategory && activeCategory == 'content'"></p>
            <p v-html="$t('cta_sub_title_2')" v-show="!activeCategory"></p>
            <a class="support-btn outline" @click="openFreshdeskForm" v-show="activeCategory && activeCategory !== 'content'">{{ $t('contact_support_button') }}</a>
        </div>
    </section>
</template>

<script>
export default {
    computed: {
        activeCategory () {
            return this.$store.getters.activeCategory;
        }
    },
    methods: {
 openFreshdeskForm: function () {
            let formOpened = this.freshDeskOpen;
            /*eslint-disable */
            if(formOpened == true){
                FreshworksWidget('close'); 
            } else {
                FreshworksWidget('open'); 
            }
            this.freshDeskOpen = !this.freshDeskOpen
            /*eslint-enable */ 
        }
    }
}
</script>
<style scoped>
    .cta-support {
        margin-top: 7vh;
    }
    .support-btn.outline {
        margin-top: 10px;
    }
</style>